import { siteData, type TopicItem } from '@/mocks/siteData';

function TopicTag({ topic }: { topic: TopicItem }) {
  const trendIcon = topic.trend === 'up' ? 'ri-arrow-up-line' : topic.trend === 'down' ? 'ri-arrow-down-line' : 'ri-fire-line';
  const trendColor = topic.trend === 'hot' ? 'text-primary-600' : topic.trend === 'up' ? 'text-accent-600' : 'text-foreground-400';

  return (
    <a
      href="#updates"
      className="group flex items-center gap-3 px-4 py-3 bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-200 cursor-pointer"
    >
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <span className="text-sm font-label font-medium text-foreground-800 truncate">{topic.name}</span>
          {topic.tag && (
            <span className="shrink-0 text-[10px] font-label px-1.5 py-0.5 rounded bg-primary-100 text-primary-700 leading-none">
              {topic.tag}
            </span>
          )}
        </div>
        <div className="flex items-center gap-1.5 mt-1">
          <i className={`${trendIcon} ${trendColor} text-xs`}></i>
          <span className="text-xs text-foreground-500">{topic.heat}热度</span>
        </div>
      </div>
      <i className="ri-arrow-right-s-line text-foreground-300 group-hover:text-primary-500 transition-colors"></i>
    </a>
  );
}

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-accent-100 text-accent-700 rounded-full text-xs font-label mb-3">
            <i className="ri-hashtag"></i>热门话题
          </div>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            大家都在搜的热门话题
          </h2>
          <p className="text-sm text-foreground-500 max-w-[500px] mx-auto">
            实时追踪娱乐圈最热话题，点击查看最新爆料详情
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3">
          {siteData.topics.map((topic) => (
            <TopicTag key={topic.id} topic={topic} />
          ))}
        </div>

        <div className="mt-6 text-center">
          <a
            href="#index"
            className="whitespace-nowrap inline-flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 font-label cursor-pointer"
          >
            查看全部话题专题
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}